var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createRoot } from "react-dom/client";
import { EmptyComponent } from "../../utils/EmptyComponent";
import { addToRegister, EventManager, unregisterAll } from "../../utils/EventManager";
import { addCheckClickOutside, applyStyleOrClass, createElementWithClass, filterChildrenOfType, trackOnElement } from "../../utils/Functions";
import { Button } from "./Button";
var SplitButton = /** @class */ (function (_super) {
    __extends(SplitButton, _super);
    function SplitButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = createElementWithClass("div", "dolfo-split-button-options-container");
        _this.events = [];
        _this.componentDidMount = function () { return addCheckClickOutside(_this.toggleRoot, _this, _this.container); };
        _this.componentWillUnmount = function () {
            setTimeout(function () { var _a; return (_a = _this.containerRoot) === null || _a === void 0 ? void 0 : _a.unmount(); });
            _this.container.remove();
            unregisterAll(_this.events);
        };
        _this.onClick = function () {
            if (_this.containerRoot)
                return _this.toggleRoot();
            var options = filterChildrenOfType(_this, OptionButton);
            _this.containerRoot = createRoot(_this.container);
            options.forEach(function (o) {
                var option = createElementWithClass("div", "dolfo-split-button-option"), _a = o.props, disabled = _a.disabled, children = _a.children, style = _a.style, className = _a.className, onClick = _a.onClick, root = createRoot(option);
                if (disabled)
                    option.classList.add("disabled");
                applyStyleOrClass(option, style, className);
                addToRegister(_this.events, new EventManager("click", function (e) {
                    if (!disabled) {
                        if (onClick)
                            onClick(e);
                        _this.toggleRoot();
                        root.unmount();
                    }
                }, option));
                root.render(children);
                _this.container.appendChild(option);
            });
            document.body.appendChild(_this.container);
            trackOnElement(_this.container, _this, false);
        };
        _this.toggleRoot = function () {
            var _a;
            (_a = _this.containerRoot) === null || _a === void 0 ? void 0 : _a.unmount();
            _this.containerRoot = null;
        };
        _this.render = function () {
            var props = _this.props;
            return React.createElement("div", { className: "dolfo-split-button-group shape-" + (props.shape || "normal"), ref: function (r) { return _this.node = r; } },
                React.createElement(Button, __assign({}, props, { onClick: _this.onClick, onMouseWheel: null, loading: false, disabled: props.disabled || props.loading }),
                    React.createElement(FontAwesomeIcon, { icon: faCaretDown })),
                React.createElement(Button, __assign({}, props, { children: props.label, onClick: function (e) {
                        if (props.onClick) {
                            props.onClick(e);
                            _this.toggleRoot();
                        }
                        else
                            _this.onClick();
                    } })));
        };
        return _this;
    }
    return SplitButton;
}(React.Component));
export { SplitButton };
var OptionButton = /** @class */ (function (_super) {
    __extends(OptionButton, _super);
    function OptionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OptionButton;
}(EmptyComponent));
export { OptionButton };
